"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promptMobileSignature = exports.listactivemobile = exports.removequeue = exports.setpadsite = exports.removemobilepad = exports.savesignature = exports.checkpadqueue = exports.findpadbytoken = exports.getorderdetails = exports.createpad = exports.getupdatedpad = exports.removepad = exports.unprovisionpad = exports.provisionpad = exports.save = exports.promptSignature = exports.listactive = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.listactive = endpoint_1.createEndpoint()({
    method: "get",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_READ,
    tokens: { siteId: "number.required" },
    path: "pad/listactive"
});
exports.promptSignature = endpoint_1.createEndpoint()({
    method: "put",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_PROMPT,
    path: "pad/prompt-signature"
});
exports.save = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "put",
    path: "pad/save"
});
exports.provisionpad = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "put",
    path: "pad/provision"
});
exports.unprovisionpad = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "delete",
    path: "pad/unprovision"
});
exports.removepad = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "delete",
    path: "pad/removepad"
});
exports.getupdatedpad = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "post",
    path: "pad/getupdatedpad"
});
exports.createpad = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "post",
    path: "pad/createpad",
});
exports.getorderdetails = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "post",
    path: "pad/getorderdetails"
});
exports.findpadbytoken = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "post",
    path: "pad/findpadbytoken"
});
exports.checkpadqueue = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "post",
    path: "pad/checkpadqueue"
});
exports.savesignature = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "post",
    path: "pad/savesignature"
});
exports.removemobilepad = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "post",
    path: "pad/removemobilepad"
});
exports.setpadsite = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "post",
    path: "pad/setpadsite"
});
exports.removequeue = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_UPDATE,
    method: "post",
    path: "pad/removequeue"
});
exports.listactivemobile = endpoint_1.createEndpoint()({
    method: "get",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_READ,
    tokens: { siteId: "number.required" },
    path: "pad/listactivemobile"
});
exports.promptMobileSignature = endpoint_1.createEndpoint()({
    method: "put",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_PAD_PROMPT,
    path: "pad/promptmobilesignature"
});



//////////////////
// WEBPACK FOOTER
// ./src/api/pad/pad-client.ts
// module id = 992
// module chunks = 0 1 2